import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { ToastContainer, toast } from "react-toastify";
import { Grid, Button, TextField, Card,Box, CardContent, CardHeader, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel } from "@mui/material";
import { useState, useEffect } from "react";
import {Dialog, DialogContent, DialogTitle} from "@mui/material";
import { Table } from "react-bootstrap";
import { useRef } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import Select from "react-select";
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import withReactContent from 'sweetalert2-react-content';
import axios from "axios";
import { saveMaterialRows } from "assets/globalAPI/GlobalApi";
import { getDocumentNo } from "assets/globalAPI/GlobalApi";
import {Typography, MenuItem} from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import { createMaterial } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchKDSMaterial } from "assets/globalAPI/apiGlobal";
import { fetchMaterialTypes } from "assets/globalAPI/apiGlobal";
import { fetchMaterialBelongsTo } from "assets/globalAPI/apiGlobal";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: 250,
    minHeight: 30,
    fontSize: "0.9rem",
    borderColor: state.isFocused ? "red" : provided.borderColor, // Change border color to red on focus
    boxShadow: state.isFocused ? "0 0 0 2px red" : "none", // Remove blue focus outline and apply red
    "&:hover": {
      borderColor: "red",
    },
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "0.85rem",
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "0.85rem",
    padding: 8,
    backgroundColor: state.isSelected ? "red" : provided.backgroundColor, // Change selected option to red
    color: state.isSelected ? "white" : provided.color, // Ensure text visibility
    "&:hover": {
      backgroundColor: "red", // Change hover effect to red
      color: "white",
    },
  }),
};
function MaterialEdit(){
    const toastId = useRef(null);
    const MySwal = withReactContent(Swal);
    const [userAccess, setUserAccess]= useState('')
    const navigate= useNavigate();
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categorySelected, setcategorySelected] = useState("");
    const [categoryUpdated, setCategoryUpdated] = useState("");
    const [userID, setUserID] = useState("");
    const [uploadFile, setUploadFile]= useState(false);
    const [formVisible, setFormVisible]= useState(false);
    const [isActive, setIsActive]= useState(false);
    const [searchLoader, setSearchLoader]= useState(false);
    const [kdsdata,setKdsData]= useState({})
    const [matTypes,setMatTypes]= useState([])
    const [allBelongs,setAllbelongs]= useState([])
    const [selectedField, setSelectedField] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [copiedFrom,setCopiedFrom]= useState("");
    const [formValues, setFormValues] = useState([
    ]);
    const [displayValues, setDisplayValues] = useState({});

    const [allvalues, setAllValues] = useState({
      ASSET: {
        material_name: "",
        product_group_description: "",
        uom: "",
        hsn_code: "",
        plant: "",
        extended_plant: "",
        belongs_to: "",
        approval_status: "pending"
      },
      STORE: {
        material_name: "",
        product_group_description: "",
        uom: "",
        hsn_code: "",
        plant: "",
        extended_plant: "",
        belongs_to: "",
        approval_status: "pending"
      },
      BROKEN_SCRAP: {
        material_name: "",
        product_group_description: "",
        uom: "",
        hsn_code: "",
        plant: "",
        extended_plant: "",
        belongs_to: "",
        approval_status: "pending"
      },
      NON_VALUATED: {
        material_name: "",
        product_group_description: "",
        uom: "",
        hsn_code: "",
        plant: "",
        extended_plant: "",
        belongs_to: "",
        approval_status: "pending"
      },
      FREE_GOODS: {
        material_name: "",
        product_group_description: "",
        uom: "",
        hsn_code: "",
        plant: "",
        extended_plant: "",
        belongs_to: "",
        approval_status: "pending"
      },
      RGP: {
        material_name: "",
        product_group_description: "",
        uom: "",
        hsn_code: "",
        plant: "",
        extended_plant: "",
        belongs_to: "",
        approval_status: "pending"
      },
      RM: {
        material_name: "",
        product_group_description: "",
        uom: "",
        hsn_code: "",
        plant: "",
        extended_plant:"",
        gst_percentage: "",
        length_mm: "",
        width_mm: "",
        height_mm: "",
        volume_cbm: "",
        lead_time_days: "",
        minimum_stock_days: "",
        maximum_stock_days: "",
        belongs_to: "",
        approval_status: "pending"
      },
      PM: {
        material_name: "",
        product_group_description: "",
        uom: "",
        hsn_code: "",
        approval_status: "",
        plant: "",
        extended_plant:"",
        gst_percentage: "",
        length_mm: "",
        width_mm: "",
        height_mm: "",
        volume_cbm: "",
        lead_time_days: "",
        minimum_stock_days: "",
        maximum_stock_days: "",
        belongs_to: "",
        approval_status: "pending"
      },
      SFG: {
        material_name: "",
        product_group_description: "",
        uom: "",
        hsn_code: "",
        approval_status: "",
        plant: "",
        extended_plant: "",
        gst_percentage: "",
        length_mm: "",
        width_mm: "",
        height_mm: "",
        volume_cbm: "",
        lead_time_days: "",
        minimum_stock_days: "",
        maximum_stock_days: "",
        belongs_to: "",
        approval_status: "pending"
      },
      FG: {
        material_name: "",
        product_brand: "",
        product_group_description: "",
        product_segment: "",
        plant: "",
        extended_plant: "",
        uom: "",
        hsn_code: "",
        sub_category: "",
        pack_weight_g: "",
        pack_format: "",
        brand_flavour: "",
        mrp: "",
        approval_status: "",
        one_cb_kgs: "",
        mrp_cb: "",
        gross_weight: "",
        length_mm: "",
        width_mm: "",
        height_mm: "",
        volume_cbm: "",
        no_of_bisc_packet: "",
        trade_point: "",
        packing_pattern: "",
        secondary_pack_quantity: "",
        type_of_secondary_pack: "",
        integration_with_dms: "",
        remarks: "",
        shelf_life: "",
        bar_code_ean_number: "",
        minimum_stock_days: "",
        lead_time_days: "",
        maximum_stock_days: "",
        availability_check: "",
        valuation_class: "",
        belongs_to: "",
        approval_status: "pending"
      }
    });
    
    


    const fieldOptions = {
      ASSET: ["Material Name", "Product Group Description","UOM", "HSN Code", "Plant","Extended Plant", "Belongs To"],
      STORE: ["Material Name", "Product Group Description","UOM","HSN Code", "Plant","Extended Plant","Belongs To"],
      BROKEN_SCRAP: ["Material Name", "Product Group Description","UOM","HSN Code", "Plant","Extended Plant","Belongs To"],
      NON_VALUATED: ["Material Name", "Product Group Description","UOM","HSN Code", "Plant","Extended Plant","Belongs To"],
      FREE_GOODS: ["Material Name", "Product Group Description","UOM","HSN Code", "Plant","Extended Plant","Belongs To"],
      RGP: ["Material Name", "Product Group Description","UOM", "HSN Code", "Plant","Extended Plant","Belongs To"],
      RM: ["Material Name", "Product Group Description","UOM", "HSN Code", "Plant","Extended Plant", "GST Percentage", "Length MM", "Width MM", "Height MM", "Volume CBM", "Lead Time Days", "Minimum Stock Days", "Maximum Stock Days","Belongs To"],
      PM: ["Material Name", "Product Group Description","UOM", "HSN Code", "Plant","Extended Plant", "GST Percentage", "Length MM", "Width MM", "Height MM", "Volume CBM", "Lead Time Days", "Minimum Stock Days", "Maximum Stock Days","Belongs To"],
      // SFG: ["Material Name", "Product Group Description","UOM", "HSN Code", "Plant", "GST Percentage", "Length MM", "Width MM", "Height MM", "Volume CBM", "Lead Time Days", "Minimum Stock Days", "Maximum Stock Days","Belongs To"],
      FG:[
        "Material Name",
        "Product Group Description",
        "Product Brand",
        "Plant",
        "Extended Plant",
        "UOM",
        "HSN Code",
        "Product Segment",
        "Sub Category",
        "Pack Weight G",
        "Pack Format",
        "MRP",
        "UOM",
        "Brand Flavour",
        "One Cb Kgs",
        "MRP CB",
        "Gross Weight",
        "Length MM",
        "Width MM",
        "Height MM",
        "Volume CBM",
        "No of Bisc Packet",
        "Trade Point",
        "Packing Pattern",
        "Secondary Pack Quantity",
        "Type of Secondary Pack",
        "Integration with DMS",
        "Remarks",
        "Shelf Life",
        "BAR CODE EAN NUMBER",
        "Minimum Stock Days",
        "Lead Time  Days",
        "Maximum Stock Days",
        "Belongs To"
      ]
      
    };

    const fieldDisplayNames = {
      "Material Name": "Material Name*",
      "Product Brand": "Product Brand*",
      "Product Group Description": "Product Group Description",
      "UOM": "UOM*",
      "HSN Code": "HSN Code*",
      "Plant": "Plant*",
      "Belongs To": "Belongs To*",
      "Extended Plant": "Extended Plants",
      "GST Percentage": "GST %",
      "Gross Weight": "Gross Weight",
      "Length MM": "Length (mm)",
      "Width MM": "Width (mm)",
      "Height MM": "Height (mm)",
      "Volume CBM": "Volume (CBM)",
      "Lead Time Days": "Lead Time(Days)*",
      "Minimum Stock Days": "Min Stock(Days)*",
      "Maximum Stock Days": "Max Stock(Days)*",
      "Product Segment": "Product Segment",
      "Sub Category": "Sub Category",
      "Pack Weight G": "Pack Size (g)",
      "Pack Format": "Pack Format",
      "MRP": "MRP",
      "Brand Flavour": "Brand Flavour",
      "One Cb Kgs": "1 CB (kg)",
      "MRP CB": "MRP/CB",
      "No of Bisc Packet": "No of Biscuits per packet",
      "Trade Point": "Trade Point",
      "Packing Pattern": "Packing Pattern",
      "Secondary Pack Quantity": "Secondary Pack Quantity",
      "Type of Secondary Pack": "Type of Secondary Pack",
      "Integration with DMS": "Integration With DMS",
      "Remarks": "Remarks",
      "Shelf Life": "Shelf Life",
      "BAR CODE EAN NUMBER": "Barcode Number",
    };
    
  
    const fieldTypes = {
      ASSET: { "Material Name": "text", "Product Group Description": "select","UOM": "select", "HSN Code": "select", "Plant": "select" ,"Extended Plant": "text", "Belongs To": "dropdown"},
      STORE: { "Material Name": "text", "Product Group Description": "select", "UOM": "select", "HSN Code": "select", "Plant": "select" ,"Extended Plant": "text", "Belongs To": "dropdown"},
      BROKEN_SCRAP: { "Material Name": "text", "Product Group Description": "select", "UOM": "select", "HSN Code": "select", "Plant": "select" ,"Extended Plant": "text", "Belongs To": "dropdown"},
      NON_VALUATED: { "Material Name": "text", "Product Group Description": "select", "UOM": "select", "HSN Code": "select", "Plant": "select" ,"Extended Plant": "text", "Belongs To": "dropdown"},
      FREE_GOODS: { "Material Name": "text", "Product Group Description": "select", "UOM": "select", "HSN Code": "select", "Plant": "select" ,"Extended Plant": "text", "Belongs To": "dropdown"},
      RGP: {"Material Name": "text","Product Group Description": "select","UOM": "select", "HSN Code": "select", "Plant": "select", "Extended Plant": "select" , "Belongs To": "dropdown"},
      RM: {"Material name": "text", "Product Group Description": "select","UOM": "select", "HSN Code": "select", "Plant": "select","Extended Plant": "text", "GST Percentage": "number",  "Length MM": "number", "Width MM": "number","Height MM": "number", "Volume CBM": "number", "Lead Time Days": "number", "Minimum Stock Days": "number", "Maximum Stock Days": "number" ,"Belongs To": "dropdown"},
      PM: {"Material name": "text", "Product Group Description": "select", "UOM": "select", "HSN Code": "select", "Plant": "select","Extended Plant": "text", "GST Percentage": "number",  "Length MM": "number", "Width MM": "number","Height MM": "number", "Volume CBM": "number", "Lead Time Days": "number", "Minimum Stock Days": "number", "Maximum Stock Days": "number", "Belongs To": "dropdown" },
      SFG: {"Material name": "text", "Product Group Description": "select","UOM": "select", "HSN Code": "select", "Plant": "select","Extended Plant": "text", "GST Percentage": "number", "Length MM": "number", "Width MM": "number","Height MM": "number", "Volume CBM": "number", "Lead Time Days": "number", "Minimum Stock Days": "number", "Maximum Stock Days": "number", "Belongs To": "dropdown" },
      FG: {
        "Material Name": "text",
        "Product Group Description": "select",
        "Product Brand": "select",
        "Plant": "select",
        "Extended Plant": "text",
        "UOM": "select",
        "HSN Code": "select",
        "Status": "select", 
        "Product Segment": "select", 
        "Sub Category": "text",
        "Pack Format": "text",
        "UOM": "select",
        "Brand Flavour": "select",
        "One Cb Kgs": "text", 
        "MRP CB": "text", 
        "Gross Weight": "number",
        "Length MM": "number", 
        "Width MM": "number", 
        "Height MM": "number",
        "Gross weight": "number", 
        "Volume CBM": "number", 
        "No of Bisc Packet": "number", 
        "Trade Point": "dropdown2",
        "Packing Pattern": "text", 
        "Secondary Pack Quantity": "text", 
        "Type of Secondary Pack": "text", 
        "Integration with DMS": "text",
        "Remarks": "textarea", 
        "Shelf Life": "number", 
        "BAR CODE EAN NUMBER": "text",
        "Minimum Stock  Days": "number", 
        "Lead Time Days": "number", 
        "Maximum Stock Days": "number", 
        "Availability check": "select", 
        "Profit Center": "select", 
        "Valuation Class": "select",
        "Belongs To": "dropdown"
      }

      
      
    };

    const tradePointValues=[
      {value: "General", label: "General"},
      {value: "Export", label: "Export"},
    ]
    const fieldToApiKeyMap = {
      "Product Group Description": "matgrp",
      "Product Brand": "prdbrand",
      "Product Segment": "prodcat",
      "HSN Code": "hsncode",
      "UOM": "matuom",
      "Plant": "matplant",
      "Profit Center": "prftcntr",
      "Extended Plant": "matplant",
      "Availability check": "avlcheck",
      "Trans Group": "transgrp",
      "Brand Flavour": "brndflvr",
      "Valuation Class": "valclass"

    };

    const belongsToMapping = {
      "ASSET": "ASSET",
      "STORE": "STORE",
      "RGP": "RGP",
      "RM": "RM",
      "PM": "PM",
      "SFG": "SFG",
      "FG": "FG",
      "BROKEN_SCRAP": "SCRAP",
      "FREE_GOODS": "FREE-GOODS",
      "NON_VALUATED": "NON-VALUED",  

    };

    const fetchAllMaterialTypes=async()=>{
      try{
        const response= await fetchMaterialTypes();
        const res= response.data;
        if(res.status){
          setMatTypes(res.data);
          console.log("mat types fetched>> ", res.data);
        }else{
          console.log("could not bring mat types>> ", res)
        }
      }catch(error){
        console.log("error bringing mat types>> ", error);
        if(error.response?.status==403){
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.error("Your Session has expired",{
              className:"small-toast"
            })
          }
          setTimeout(()=>{
            navigate("/")
            localStorage.clear();
          },2000)
          return;
        }
      }
    }
    
    const fetchAllMaterialBelongsTo=async(type)=>{
      const body={
        "material_type":type
      }
      try{
        const response= await fetchMaterialBelongsTo(body);
        const res= response.data;
        if(res.status){
          
const mapped = res.data?.map(item => ({
  value: item.belongs_to,
  label: item.belongs_to
}));
          setAllbelongs(mapped);
          console.log("belongs to fetched>> ", res.data);
        }else{
          console.log("could not bring mat belongs>> ", res)
        }
      }catch(error){
        console.log("error bringing mat belongs>> ", error);
        if(error.response?.status==403){
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.error("Your Session has expired",{
              className:"small-toast"
            })
          }
          setTimeout(()=>{
            navigate("/")
            localStorage.clear();
          },2000)
          return;
        }
      }
    }

    function capitalizeInitials(str) {
      return str
        .split(/(\s+)/) // this keeps the spaces too
        .map(word => {
          return word.trim() ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word;
        })
        .join('');
    }

    const productDescOptions= [
      {value: "IT", label: "IT"},
      {value: "Steel", label: "Steel"}
    ]
    const uomOptions= [
      {value: "KG", label: "KG"},
      {value: "LBS", label: "LBS"}
    ]

    const plantoptions= [
      {value: "Kolkata", label: "Kolkata"},
      {value: "Mumbai", label: "Mumbai"}
    ]
    const belongstooptions= [
      {value: "IT", label: "IT"},
      {value: "Project", label: "Project"},
      {value: "Others", label: "Others"},
    ]

    const belongstooptions2= [
      {value: "Others", label: "Others"},
    ]

    const fieldValues={
      ASSET: {"Belongs To": belongstooptions},
      STORE: {"Belongs To": belongstooptions2},
      RGP: {"Belongs To": belongstooptions2},
      RM: {"Belongs To": belongstooptions2},
      PM: {"Belongs To": belongstooptions2},
      SFG: {"Belongs To": belongstooptions2},
      FG: {"Belongs To": belongstooptions2},
    }

    const forShow={
      "ASSET": "ASSET",
      "STORE":"STORE",
      "RGP":"RGP",
      "BROKEN_SCRAP":"SCRAP",
      "FREE_GOODS":"FREE GOODS/SCHEME",
      "NON_VALUATED": "BROKEN/DAMAGED",
      "RM":"RM",
      "PM":"PM",
      "SFG":"SFG",
      "FG":"FG"
    }
  
    const categoryOptions = Object.keys(fieldOptions).map((key) => ({
      value: key,
      label: forShow[key],
    }));

    
          const fetchAllMaterialKDS=async()=>{
            try{
              const response= await fetchKDSMaterial();
              const res= response.data;
              if(res.status){
                setKdsData(res.data);
                console.log("kds fetched>> ", res.data);
              }else{
                console.log("could not bring vendor kds>> ", res)
              }
            }catch(error){
              console.log("error bringing material KDS>> ", error);
              if(error.response?.status==403){
                if(!toast.isActive(toastId.current)){
                  toastId.current= toast.error("Your Session has expired",{
                    className:"small-toast"
                  })
                }
                setTimeout(()=>{
                  navigate("/")
                  localStorage.clear();
                },2000)
                return;
              }
            }
          }

          useEffect(() => {
            const copiedMaterial = localStorage.getItem("editMaterial");
            if (copiedMaterial) {
              const parsed = JSON.parse(copiedMaterial);
              setcategorySelected(parsed.material_type);
              setCopiedFrom(parsed.material_id);
              setSelectedCategory({ value: parsed.material_type, label: parsed.material_type });
          
              // Convert backend keys to frontend field names
              const mappedValues = Object.fromEntries(
                fieldOptions[parsed.material_type].map((field) => {
                  const key = field.toLowerCase().replace(/\s+/g, "_");
                  const value =
                    field === "Belongs To" && parsed.material_type !== "ASSET"
                      ? "Other"
                      : parsed[key] || "";
                  return [field, value];
                })
              );
              
              console.log("here are mapped values>> ", mappedValues)
              setFormValues([mappedValues]);

              setAllValues((prev) => ({
                ...prev,
                [parsed.material_type]: {
                  ...prev[parsed.material_type],
                  ...Object.fromEntries(
                    Object.keys(prev[parsed.material_type]).map((key) => [
                      key,
                      key === "approval_status" ? "pending" : parsed[key] || "",
                    ])
                  ),
                },
              }));
            } 
          }, []);

          useEffect(() => {
                const handler = setTimeout(() => {
                  setSearchLoader(true); // Show loader AFTER 2 sec pause
                  setDebouncedSearch(searchTerm);
              
                  // Simulate async filtering (optional delay or set false immediately after)
                  setTimeout(() => {
                    setSearchLoader(false); // Hide loader after data is "ready"
                  }, 100); // tweak delay if needed
                }, 600); // Wait for user to stop typing
              
                return () => clearTimeout(handler); // Cleanup if typing again
              }, [searchTerm]);
            
          

          const filteredData = kdsdata[selectedField?.apiKey]?.filter(
            (item) =>
              item.label.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
              item.value.toLowerCase().includes(debouncedSearch.toLowerCase())
          );
  

    const handleCategoryChange = (selectedOption) => {
      console.log("selected cat>>> ", selectedOption)
      setSelectedCategory(selectedOption);
      setcategorySelected(selectedOption.value)
      setFormValues([{
        ...Object.fromEntries(
          fieldOptions[selectedOption.value].map((field) => [
            field
          ])
        )
      }]);
      
      fetchAllMaterialBelongsTo(belongsToMapping[selectedOption.value]);
      console.log("here is the category>> ",Object.fromEntries(fieldOptions[selectedOption.value].map((field) => [field, ""])) )
    };

    const addRow=()=>{
      setFormValues([...formValues, Object.fromEntries(fieldOptions[selectedCategory.value].map((field) => [field, ""]))])
    }
    const deleteRow = () => {
      if (formValues.length > 1) {
        setFormValues(formValues.slice(0, -1));
      }
    };
  
    // const handleInputChange = (index, field, value) => {
    //   const newFormValues = [...formValues];
    //   newFormValues[index][field] = value;
    //   setFormValues(newFormValues);
    // };

    const handleUploadType=(e)=>{
      let uplaod_type = event.target.value;
      if(uplaod_type==="yes"){
        setUploadFile(true);
        setFormVisible(false)
      }else{
        setUploadFile(false)
        setFormVisible(true)
      }
    }

    const handleDropdownClick = (field) => {
      const apiKey = fieldToApiKeyMap[field]; // Get API key from mapping
      if (apiKey && kdsdata[apiKey]) {
        setSelectedField({ field, apiKey }); // Store selected field details
        setDialogOpen(true);
      }
    };
    

    const handleSelect = (value, label) => {
      const formattedField = selectedField.field.toLowerCase().replace(/\s+/g, "_");
    
      setAllValues((prevValues) => {
        const updatedValues = { ...prevValues };
        const category = selectedCategory.value;
    
        updatedValues[category] = {
          ...updatedValues[category],
          [formattedField]: value, // Store only value
        };
    
        setCategoryUpdated(category);
        return updatedValues;
      });
    
      // Store the label for UI display
      setDisplayValues((prev) => ({
        ...prev,
        [selectedCategory.value]: {
          ...prev[selectedCategory.value],
          [formattedField]: label, // Store label under category
        },
      }));

      setFormValues((prevFormValues) => {
        const updatedFormValues = [...prevFormValues];
        
        // Loop through each object in the array
        updatedFormValues.forEach((obj) => {
          if (obj.hasOwnProperty(selectedField.field)) {
            obj[selectedField.field] = value; // update the value for the matching field name
          }
        });
    
        return updatedFormValues;
      });
    
      setDialogOpen(false);
      setSearchTerm("")
    };
    
    
    
    

    // const handleInputChange = (index, field, value) => {
    //   const formattedField = field.toLowerCase().replace(/\s+/g, "_");
    //   console.log("the field is>> ", field)
      
    //   // Update formValues so the UI re-renders correctly
    //   setFormValues((prevFormValues) => {
    //     const updatedFormValues = [...prevFormValues];
    //     updatedFormValues[index] = {
    //       ...updatedFormValues[index],
    //       [field]: value, // use original field casing here, since formValues use field like "Material Name"
    //     };
    //     return updatedFormValues;
    //   });
    
    //   // Update allValues too (for backend or form state usage)
    //   setAllValues((prevValues) => {
    //     const updatedValues = { ...prevValues };
    //     const category = selectedCategory.value;
    
    //     updatedValues[category] = {
    //       ...updatedValues[category],
    //       [formattedField]: value
    //     };
    
    //     setCategoryUpdated(category);
    //     return updatedValues;
    //   });
    // };

    const handleInputChange = (index, field, value) => {
      const formattedField = field.toLowerCase().replace(/\s+/g, "_");
      console.log("the field is>> ", field);
    
      // === Update formValues (UI) ===
      setFormValues((prevFormValues) => {
        const updatedFormValues = [...prevFormValues];
        const currentRow = { ...updatedFormValues[index], [field]: value };
    
        // Extract values safely
        let width_mm;
        let length_mm;
        let height_mm;
        if(selectedCategory.value === "FG"){

           width_mm = Number(field === "Width MM" ? value : currentRow["Width MM"]);
         length_mm = Number(field === "Length MM" ? value : currentRow["Length MM"]);
           height_mm = Number(field === "Height MM" ? value : currentRow["Height MM"]);

        }
        const pack_weight_g = Number(field === "Pack Weight G" ? value : currentRow["Pack Weight G"]);
        const pack_format = Number(field === "Pack Format" ? value : currentRow["Pack Format"]);
        let mrp = Number(field === "MRP" ? value : currentRow["MRP"]);
    
        // Default mrp to 0 if blank or NaN
        mrp = isNaN(mrp) ? 0 : mrp;
    
        // one_cb_kgs = (pack_weight_g * pack_format) / 1000
        if (!isNaN(pack_weight_g) && !isNaN(pack_format)) {
          currentRow["One Cb Kgs"] = (pack_weight_g * pack_format) / 1000;
        }
    
        // mrp_cb = mrp * pack_format
        if (!isNaN(pack_format)) {
          currentRow["MRP CB"] = mrp * pack_format;
        }

        if(selectedCategory.value=="FG"){

          if (!isNaN(width_mm)&& !isNaN(length_mm) && !isNaN(height_mm)) {
            currentRow["Volume CBM"] = ((width_mm * length_mm * height_mm) / 1000000000).toFixed(10); // Convert mm^3 to m^3
          }
        }

        
    
        updatedFormValues[index] = currentRow;
        return updatedFormValues;
      });
    
      // === Update allValues (backend/state) ===
      setAllValues((prevValues) => {
        const updatedValues = { ...prevValues };
        const category = selectedCategory.value;
        const prevCategoryValues = updatedValues[category] || {};
        let width_mm, length_mm, height_mm;
        if(selectedCategory.value === "FG"){
           width_mm = Number(field === "Width MM" ? value : prevCategoryValues["width_mm"]);
           length_mm = Number(field === "Length MM" ? value : prevCategoryValues["length_mm"]);
           height_mm = Number(field === "Height MM" ? value : prevCategoryValues["height_mm"]);

        }
        const pack_weight_g = Number(field === "Pack Weight G" ? value : prevCategoryValues["pack_weight_g"]);
        const pack_format = Number(field === "Pack Format" ? value : prevCategoryValues["pack_format"]);
        let mrp = Number(field === "MRP" ? value : prevCategoryValues["mrp"]);
    
        mrp = isNaN(mrp) ? 0 : mrp;
    
        const calculatedValues = {};
    
        if (!isNaN(pack_weight_g) && !isNaN(pack_format)) {
          calculatedValues["one_cb_kgs"] = (pack_weight_g * pack_format) / 1000;
        }
    
        if (!isNaN(pack_format)) {
          calculatedValues["mrp_cb"] = mrp * pack_format;
        }

        if(selectedCategory.value === "FG"){

          if (!isNaN(width_mm)&& !isNaN(length_mm) && !isNaN(height_mm)) {
            calculatedValues["volume_cbm"] = ((width_mm * length_mm * height_mm) / 1000000000).toFixed(10); // Convert mm^3 to m^3
          }
        }

        
    
        updatedValues[category] = {
          ...prevCategoryValues,
          [formattedField]: value,
          ...calculatedValues,
        };
    
        setCategoryUpdated(category);
        return updatedValues;
      });
    };
    
    
    
    

    const handleDownload = (e) => {
      e.preventDefault();
      const fileMap = {
        ASSET: `${window.location.origin}/ASSET_creation_sample.xlsx`,
        STORE: `${window.location.origin}/STORE_creation_sample.xlsx`,
        RGP: `${window.location.origin}/RGP_creation_sample.xlsx`,
        "RM PM SFG": `${window.location.origin}/RM_PM_SFG_creation_sample.xlsx`,
        FG: `${window.location.origin}/FG_creation_sample.xlsx`,
      };

      const fileUrl = fileMap[categorySelected];
      console.log("file url is>> ", fileUrl)

    if (!fileUrl) {
      if(!toast.isActive(toastId.current)){
        toastId.current= toast.warning("File Not found in the site",{
          className:"small-toast"
        })
      }
      return;
    }
  
      const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", fileUrl.split("/").pop()); // Set download filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    };

    const getFormattedDateTime = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
    
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
  
    const saveMaterial = async() => {
      setIsActive(true)
      console.log("Saved Data:", allvalues);
     
      const category= selectedCategory.value;

      const body={
        ...allvalues[category], 
        material_type: category ,
        created_by: userID,
        copied_from: copiedFrom,
        created_on: getFormattedDateTime()
      }

      const requiredFields = ["material_name","product_brand", "uom", "plant","hsn_code","belongs_to"];
      if (selectedCategory.value === "RM" || selectedCategory.value === "PM") {
        requiredFields.push("lead_time_days", "minimum_stock_days", "maximum_stock_days"); // replace with actual field names
      }
      const currentValues = allvalues[category];
      const missingFields = requiredFields.filter(
        field => currentValues.hasOwnProperty(field) && currentValues[field].trim() === ""
      );

      if (missingFields.length > 0) {
       setIsActive(false)
       if(!toast.isActive(toastId.current)){
        toastId.current= toast.error(`Please fill all mandatory fields: ${missingFields.join(", ")}`,{
          className:"small-toast"
        })
      }
        console.log("Please fill all mandatory fields:", missingFields.join(", "));
        return;
      }


      console.log("here is saved material body>> ", body)

      try{
        const response= await createMaterial(body);
        const res= response.data;
        console.log("the response is>> ", res)
        if(res.status){
          setIsActive(false)
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.success(res.message,{
              className:"small-toast"
            })
          }
          localStorage.removeItem("editMaterial");
          setCopiedFrom("");
          // localStorage.removeItem("materialSaved")
          console.log("the success res is>> ", res)
  //         let storedData = localStorage.getItem("materialSaved");
  // let parsedData = storedData ? JSON.parse(storedData) : {}; 
  // if (!parsedData[categorySelected]) {
  //   parsedData[categorySelected] = {};
  // }
  //         parsedData[categorySelected] = {
  //           ...parsedData[categorySelected], // Keep existing fields for this material type
  //           ...allvalues[categorySelected], // Replace with new values
  //         };
          localStorage.setItem("materialSaved", JSON.stringify(allvalues));
          setTimeout(()=>{
            navigate("/materials-list")
          },2000)
        }else{
          setIsActive(false)
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.warning(res.message,{
              className:"small-toast"
            })
          }

          console.log("Why not save>> ", res)
        }
      }catch(error){
        console.log("Error saving material>> ", error)
        if(error.response?.status==403){
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.error("Your Session has expired",{
              className:"small-toast"
            })
          }
          setTimeout(()=>{
            navigate("/")
            localStorage.clear();
          },2000)
          return;
        }
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error(error.message,{
            className:"small-toast"
          })
        }
        setIsActive(false)
      }

      let storedData = localStorage.getItem("materialSaved");
  let parsedData = storedData ? JSON.parse(storedData) : {}; 
  if (!parsedData[categorySelected]) {
    parsedData[categorySelected] = {};
  }

  // Update only the specific material type, keeping other types untouched
  parsedData[categorySelected] = {
    ...parsedData[categorySelected], // Keep existing fields for this material type
    ...allvalues[categorySelected], // Replace with new values
  };
  localStorage.setItem("materialSaved", JSON.stringify(parsedData));
      // if(!toast.isActive(toastId.current)){
      //   toastId.current= toast.success("Material Saved Successfully",{
      //     className:"small-toast"
      //   })
      // }
      // navigate("/materials-list")
    };
    const saveMaterial2 = async() => {
      setIsActive(true)
      console.log("Saved Data:", allvalues);
     
      const category= selectedCategory.value;

      const body={
        ...allvalues[category], 
        material_type: category ,
        created_by: userID,
        copied_from: copiedFrom,
        created_on: getFormattedDateTime()
      }

      const requiredFields = ["material_name","product_brand", "uom", "plant","hsn_code","belongs_to"];
      const currentValues = allvalues[category];
      const missingFields = requiredFields.filter(
        field => currentValues.hasOwnProperty(field) && currentValues[field].trim() === ""
      );

      if (missingFields.length > 0) {
       setIsActive(false)
       if(!toast.isActive(toastId.current)){
        toastId.current= toast.error(`Please fill all mandatory fields: ${missingFields.join(", ")}`,{
          className:"small-toast"
        })
      }
        console.log("Please fill all mandatory fields:", missingFields.join(", "));
        return;
      }

      console.log("here is saved material body>> ", body)

      try{
        const response= await createMaterial(body);
        const res= response.data;
        console.log("the response is>> ", res)
        if(res.status){
          setIsActive(false)
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.success(res.message,{
              className:"small-toast"
            })
          }
          setDisplayValues((prev) => ({
            ...prev,
            [selectedCategory.value]: {
              ...prev[selectedCategory.value],
              material_name: ""
            },
          }));
          setFormValues((prevFormValues) => {
            const updatedFormValues = prevFormValues.map((obj) => ({
              ...obj,
              "Material Name": ""
            }));
            return updatedFormValues;
          });
                    
          setAllValues((prev) => ({
            ...prev,
            [selectedCategory.value]: {
              ...prev[selectedCategory.value],
              material_name: ""
            }
          }));
          
          // localStorage.removeItem("copiedMaterial");
          // localStorage.removeItem("materialSaved")
          console.log("the success res is>> ", res)
  //         let storedData = localStorage.getItem("materialSaved");
  // let parsedData = storedData ? JSON.parse(storedData) : {}; 
  // if (!parsedData[categorySelected]) {
  //   parsedData[categorySelected] = {};
  // }
  //         parsedData[categorySelected] = {
  //           ...parsedData[categorySelected], // Keep existing fields for this material type
  //           ...allvalues[categorySelected], // Replace with new values
  //         };
          localStorage.setItem("materialSaved", JSON.stringify(allvalues));
        }else{
          setIsActive(false)
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.warning(res.message,{
              className:"small-toast"
            })
          }

          console.log("Why not save>> ", res)
        }
      }catch(error){
        console.log("Error saving material>> ", error)
        if(error.response?.status==403){
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.error("Your Session has expired",{
              className:"small-toast"
            })
          }
          setTimeout(()=>{
            navigate("/")
            localStorage.clear();
          },2000)
          return;
        }
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error(error.message,{
            className:"small-toast"
          })
        }
        setIsActive(false)
      }

  //     let storedData = localStorage.getItem("materialSaved");
  // let parsedData = storedData ? JSON.parse(storedData) : {}; 
  // if (!parsedData[categorySelected]) {
  //   parsedData[categorySelected] = {};
  // }

  // // Update only the specific material type, keeping other types untouched
  // parsedData[categorySelected] = {
  //   ...parsedData[categorySelected], // Keep existing fields for this material type
  //   ...allvalues[categorySelected], // Replace with new values
  // };
  // localStorage.setItem("materialSaved", JSON.stringify(parsedData));
      // if(!toast.isActive(toastId.current)){
      //   toastId.current= toast.success("Material Saved Successfully",{
      //     className:"small-toast"
      //   })
      // }
      // navigate("/materials-list")
    };

    useEffect(()=>{
      fetchAllMaterialKDS()
      let storedData = localStorage.getItem("materialSaved");
      let parsedData = storedData ? JSON.parse(storedData) : {}; 
      console.log("parsed>>> ", parsedData)
      let userDetails= localStorage.getItem("userdetails");
      if(userDetails){

        let user= JSON.parse(userDetails);
        setUserID(user.id);
        console.log("here is id>> ", user.id)
      }
    },[]);

      return(
        <DashboardLayout>
            <DashboardNavbar/>
            <ToastContainer/>
            <SimpleBackdrop openLoader={isActive}/>
            
            <Grid>
              

            <form>
  <Select
    options={categoryOptions}
    isDisabled
    value={[
      { value: selectedCategory?.value, label: selectedCategory?.label, } // Set the selected category as the value
    ]}
    onChange={handleCategoryChange}
    placeholder="Select Material Type"
    styles={{
      ...customStyles,
      control: (provided) => ({
        ...provided,
        minHeight: "40px",
        fontSize: "14px",
      }),
    }}
  />
{/* {selectedCategory && (
  <Card sx={{ mt: 3, p: 2, boxShadow: 3, borderRadius: 2 }}>
    <CardContent>
      <SoftBox mt={1}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <SoftBox mb={3}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <FormControl>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    <SoftTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      textTransform="capitalize"
                    >
                      Do you want to create multiple materials?*
                    </SoftTypography>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" onChange={handleUploadType} />
                    <FormControlLabel value="no" control={<Radio />} label="No" onChange={handleUploadType} />
                  </RadioGroup>
                </FormControl>
              </SoftBox>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>

      {uploadFile ? (
        <SoftBox mt={1}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <SoftBox mb={3}>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    Upload Document
                  </SoftTypography>
                </SoftBox>
                <SoftInput
                  type="file"
                  size="medium"
                  name="pdf_file"
                  id="pdf_file"
                  multiple
                />
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Sample format <a href="#" onClick={handleDownload}>Click here</a>
                </SoftTypography>
              </SoftBox>
            </Grid>
          </Grid>
        </SoftBox>
      ) : null}
    </CardContent>
  </Card>
)} */}

  
  {selectedCategory && (
    <Card sx={{ mt: 3, p: 2, boxShadow: 3, borderRadius: 2 }}>
      <CardHeader title="Material Details" />
      <CardContent>
        <SoftBox py={2} style={{ overflowX: "auto" }}>
          {formValues.map((row, index) => (
           <Grid container key={index} alignItems="center" spacing={2} sx={{ mb: 2 }}>
              {Object.keys(row).map((field) => (
                <Grid item xs={3} key={field}>
                  <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px">
                  {fieldDisplayNames[field] ||  field.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())}
                  </Typography>

                  {fieldTypes[selectedCategory.value]?.[field] === "select" ? (
  // Prevents dialog opening for "Belongs To"
    <div key={index} onClick={() => handleDropdownClick(field)}>
    <SoftInput
      fullWidth
      readOnly
      value={
        displayValues[selectedCategory.value]?.[field.toLowerCase().replace(/\s+/g, "_")] || row[field] || "Select an option"
      }
    />
  </div>
 
   
 
  
                    // <SoftSelect
                    //   name="dummy"
                    //   id="dummy"
                    //   menuPlacement="auto"
                    //   menuPortalTarget={document.body} 
                    //   options={fieldValues.ASSET?.[field] || []}
                    //   onChange={(e) => handleInputChange(index, field, e.value)}
                    // />
                  ) : fieldTypes[selectedCategory.value]?.[field] === "textarea" ? (
                    <TextField
                      multiline
                      rows={3}
                      value={row[field]}
                      onChange={(e) => handleInputChange(index, field, e.target.value)}
                      size="small"
                      fullWidth
                    />
                  ) :fieldTypes[selectedCategory.value]?.[field] === "dropdown" ?(
                    <SoftSelect
                    menuPlacement="auto"
                    onChange={(e) => handleInputChange(index, field, e.value)}
                    menuPortalTarget={document.body}
                    value={[{ value: row[field], label: row[field] }]}
                    options={allBelongs}
                  />
                  ):fieldTypes[selectedCategory.value]?.[field] === "dropdown2" ?(
                    <SoftSelect
                    menuPlacement="auto"
                    onChange={(e) => handleInputChange(index, field, e.value)}
                    menuPortalTarget={document.body}
                    value={[{ value: row[field], label: row[field] }]}
                    options={tradePointValues}
                  />
                  ) :
                  
                  (
                    <SoftInput
                      type={fieldTypes[selectedCategory.value]?.[field] || "text"}
                      value={row[field]}
                      onChange={(e) => {
                        let capitalWords= capitalizeInitials(e.target.value)
                        handleInputChange(index, field, field=="Material Name"?e.target.value:capitalWords)}}
                      name="dummy2"
                      id="dummy2"
                    />
                  )}
                </Grid>
              ))}
                

                
            </Grid>
          ))}
        </SoftBox>
      </CardContent>
    </Card>
  )}

  {selectedCategory && (
    <Grid container spacing={2} mt={2}>
    <Grid item>
      <Box display="flex" gap={2}>
        <SoftButton variant="gradient" color="success" onClick={saveMaterial}>
          Save
        </SoftButton>
        {/* <SoftButton  variant="contained" color="info" onClick={saveMaterial2}>
          Save & Duplicate
        </SoftButton> */}
        {/* <SoftButton style={{display: categorySelected== "FG" ? 'none': ''}} variant="contained" color="error" onClick={deleteRow}>
          Delete Row
        </SoftButton> */}
      </Box>
    </Grid>
  </Grid>
  
  )}
</form>
</Grid>


  <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
    <SimpleBackdrop openLoader={searchLoader}/>
  <DialogTitle>Select an Option</DialogTitle>
  <DialogContent>
  <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: "100%",
            padding: "5px",
            marginBottom: "10px",
            fontSize: "12px",
          }}
        />
        <SoftButton
                    onClick={() => handleSelect("", "")}
                    style={{
                      marginBottom: "10px",
                      backgroundColor: "#ccc",
                      border: "none",
                      padding: "5px 10px",
                      fontSize: "12px",
                      cursor: "pointer",
                      borderRadius: "4px"
                    }}
                  >
                    Clear Selection
                  </SoftButton>
  <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
  <thead>
  <tr style={{ color: "white", backgroundColor: "#3498db" }}>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Label</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
        </tr>
      </thead>
      <tbody>
  {selectedField &&
    filteredData?.map((item, index) => (
      <tr key={index} onClick={() => handleSelect(item.value, item.label)}>
        <th style={{ backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.label}</th>
        <th style={{ backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.value}</th>
      </tr>
    ))}
</tbody>
    </Table>
  </DialogContent>
</Dialog>
          

        </DashboardLayout>
    )
}

export default MaterialEdit;